var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 891,
    height: 290,
    viewBox: "0 0 891 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 177.247L37.7586 197.867L122.17 148.896L85.1205 128.276L2 177.247Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20312 227.629L37.9617 248.248L122.373 199.278L85.3237 178.664L2.20312 227.629Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7617 197.866V248.248",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 148.434V198.821",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 176.887V228.577",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7578 197.403L73.5224 218.023L157.928 169.052L120.878 148.433L37.7578 197.403Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9609 247.791L73.7255 268.405L158.131 219.44L121.082 198.82L37.9609 247.791Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5234 218.022V268.404",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.246 168.59V218.977",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7578 197.049V248.733",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 126.865L37.7586 147.479L122.17 98.5141L85.1205 77.8945L2 126.865Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20312 177.247L37.9617 197.867L122.373 148.896L85.3237 128.276L2.20312 177.247Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7617 147.479V197.867",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 98.0518V148.433",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 126.505V178.195",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9648 147.022L73.7294 167.642L158.135 118.671L121.085 98.0518L37.9648 147.022Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.168 197.404L73.9266 218.024L158.338 169.053L121.288 148.434L38.168 197.404Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7305 167.642V218.023",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.453 118.209V168.59",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9648 146.662V198.352",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7617 217.998L109.526 238.618L193.931 189.647L156.882 169.027L73.7617 217.998Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9648 268.38L109.729 288.999L194.135 240.029L157.085 219.409L73.9648 268.38Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.527 238.617V288.999",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.25 189.185V239.566",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7617 217.638V269.328",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9648 167.611L109.729 188.231L194.135 139.26L157.085 118.641L73.9648 167.611Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.168 217.999L109.933 238.613L194.338 189.648L157.289 169.028L74.168 217.999Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.73 188.23V238.618",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.453 138.804V189.185",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9648 167.257V218.947",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2 76.6514L37.7586 97.2709L122.17 48.3002L85.1205 27.6807L2 76.6514Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20312 127.034L37.9617 147.654L122.373 98.6829L85.3237 78.0693L2.20312 127.034Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7617 97.2705V147.652",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 47.8379V98.2252",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2 76.291V127.981",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9648 96.8086L73.7294 117.428L158.135 68.4574L121.085 47.8379L37.9648 96.8086Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.168 147.19L73.9266 167.81L158.338 118.845L121.288 98.2256L38.168 147.19Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7305 117.428V167.809",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M157.453 67.9951V118.382",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9648 96.4482V148.138",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9648 117.404L109.729 138.018L194.135 89.0531L157.085 68.4336L73.9648 117.404Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.168 167.786L109.933 188.406L194.338 139.435L157.289 118.815L74.168 167.786Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M109.73 138.019V188.406",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M193.453 88.5908V138.972",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9648 117.043V168.733",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 177.247L593.319 197.867L677.724 148.896L640.675 128.276L557.555 177.247Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M557.758 227.629L593.516 248.248L677.928 199.278L640.878 178.664L557.758 227.629Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32 197.866V248.248",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M677.043 148.434V198.821",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 176.887V228.577",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32 197.404L629.079 218.024L713.484 169.053L676.435 148.434L593.32 197.404Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M593.516 247.792L629.28 268.406L713.685 219.441L676.636 198.821L593.516 247.792Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M629.082 218.023V268.405",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M712.805 168.591V218.978",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32 197.05V248.734",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 126.864L593.319 147.478L677.724 98.5131L640.675 77.8936L557.555 126.864Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M557.758 177.246L593.516 197.866L677.928 148.895L640.878 128.275L557.758 177.246Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32 147.479V197.866",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M677.043 98.0508V148.432",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 126.504V178.194",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M593.516 147.022L629.28 167.642L713.685 118.671L676.636 98.0518L593.516 147.022Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M593.719 197.404L629.483 218.024L713.889 169.053L676.839 148.434L593.719 197.404Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M629.281 167.642V218.023",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M713.004 118.209V168.59",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M593.516 146.661V198.351",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M840.228 50.3955L804.47 71.0151L720.059 22.0444L757.108 1.4248L840.228 50.3955Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M840.025 100.777L804.267 121.397L719.855 72.4262L756.905 51.8066L840.025 100.777Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M804.469 71.0146V121.396",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M720.738 21.582V71.9694",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M840.23 50.0352V101.725",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M767.941 150.99L803.7 171.61L888.111 122.639L851.062 102.02L767.941 150.99Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M768.145 201.372L803.903 221.992L888.314 173.021L851.265 152.401L768.145 201.372Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M803.703 171.609V221.991",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M887.43 122.177V172.564",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M767.941 150.63V202.32",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 76.6524L593.319 97.2719L677.724 48.3012L640.675 27.6816L557.555 76.6524Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M557.758 127.034L593.516 147.654L677.928 98.6829L640.878 78.0693L557.758 127.034Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M593.32 97.2715V147.653",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M677.043 47.8389V98.2262",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M557.555 76.292V127.982",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M636.574 71.6161L672.333 92.2356L756.744 43.2649L719.695 22.6514L636.574 71.6161Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M636.777 122.004L672.536 142.623L756.947 93.6528L719.898 73.0332L636.777 122.004Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M672.336 92.2363V142.624",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M756.062 42.8086V93.19",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M636.574 71.2607V122.951",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M767.941 100.776L803.7 121.396L888.111 72.4252L851.062 51.8057L767.941 100.776Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M768.145 151.164L803.903 171.778L888.314 122.813L851.265 102.193L768.145 151.164Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M803.703 121.396V171.777",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M887.43 71.9629V122.35",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M767.941 100.422V152.106",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 177.247L298.552 197.867L382.963 148.896L345.913 128.276L262.793 177.247Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M262.996 227.629L298.755 248.248L383.166 199.278L346.117 178.664L262.996 227.629Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M298.555 197.866V248.248",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M382.277 148.434V198.821",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 176.887V228.577",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M298.547 197.404L334.312 218.024L418.717 169.053L381.667 148.434L298.547 197.404Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M298.75 247.792L334.509 268.406L418.92 219.441L381.871 198.821L298.75 247.792Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M334.312 218.023V268.405",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M418.035 168.591V218.978",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M298.547 197.05V248.734",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 126.864L298.552 147.478L382.963 98.5131L345.913 77.8936L262.793 126.864Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M262.996 177.246L298.755 197.866L383.166 148.895L346.117 128.275L262.996 177.246Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M298.555 147.479V197.866",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M382.277 98.0508V148.432",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 126.504V178.194",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M334.961 126.09L370.725 146.709L455.131 97.7387L418.081 77.1191L334.961 126.09Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M335.164 176.472L370.923 197.091L455.334 148.121L418.285 127.501L335.164 176.472Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M370.727 146.709V197.09",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M454.449 97.2764V147.664",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M334.961 125.729V177.419",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M334.551 217.999L370.315 238.619L454.721 189.648L417.671 169.028L334.551 217.999Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M334.754 268.381L370.518 289L454.924 240.03L417.874 219.41L334.754 268.381Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M370.316 238.618V289",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M454.039 189.186V239.567",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M334.551 217.639V269.329",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M370.965 146.681L406.729 167.3L491.135 118.33L454.085 97.71L370.965 146.681Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M371.168 197.068L406.933 217.682L491.338 168.717L454.289 148.098L371.168 197.068Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M406.73 167.3V217.687",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M490.453 117.873V168.254",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M370.965 146.326V198.016",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 76.6524L298.552 97.2719L382.963 48.3012L345.913 27.6816L262.793 76.6524Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M262.996 127.034L298.755 147.654L383.166 98.6829L346.117 78.0693L262.996 127.034Z",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M298.555 97.2715V147.653",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M382.277 47.8389V98.2262",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M262.793 76.292V127.982",
    stroke: "white",
    strokeWidth: 1.12252,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M334.961 75.8779L370.725 96.4975L455.131 47.5268L418.081 26.9072L334.961 75.8779Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M335.164 126.26L370.923 146.879L455.334 97.9145L418.285 77.2949L335.164 126.26Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M370.727 96.4971V146.878",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M454.449 47.0645V97.4518",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M334.961 75.5176V127.208",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M370.965 96.4727L406.729 117.086L491.135 68.1215L454.085 47.502L370.965 96.4727Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M371.168 146.854L406.933 167.474L491.338 118.503L454.289 97.8838L371.168 146.854Z",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M406.73 117.087V167.474",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M490.453 67.6592V118.041",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M370.965 96.1123V147.802",
    stroke: "#26483E",
    strokeWidth: 1.9509,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.def306e23c49f5d9b4dfcf0b28cc3646.svg";
export { ForwardRef as ReactComponent };